<template>
	<div>
		<div v-if="logoURL === null">
			<h1
				id="data-dz-thumbnail"
				style="margin-left: 12px"
			>
				{{ organization && organization.billing_name ? organization.billing_name : $t("Votre logo") }}
			</h1>

			<div
				class="btn-image"
				@click="openFileInput"
			>
				<b-form-file
					id="fileInput"
					type="file"
					accept=".png, .jpg, .jpeg"
					style="display: none"
					@change="uploadImage"
				/>
				<b-icon
					icon="plus"
					aria-hidden="true"
					class="font-size-icon"
				/>
				{{ $t("Ajouter mon logo") }}
			</div>

			<b-overlay
				:show="uploading"
				no-wrap
				class="d-inline-block"
			>
				<template #overlay>
					<div
						v-if="uploading"
						:style="{
							'background-color': background,
							color: foreground
						}"
						class="text-center p-3 rounded"
					>
						<b-icon
							icon="cloud-upload"
							font-scale="4"
						/>
						<div class="mb-3">
							{{ $t("Téléchargement...") }}
						</div>
					</div>
				</template>
			</b-overlay>
		</div>

		<div
			v-else
			@mouseover="showRemoveImage(true)"
			@mouseleave="showRemoveImage(false)"
		>
			<b-img
				id="data-dz-thumbnail"
				:src="logoURL"
				alt="Logo"
				class="logo"
			/>
			<div
				v-if="hovering"
				class="btn-image"
				@click="removeImage"
			>
				<b-icon
					icon="x"
					aria-hidden="true"
					class="font-size-icon"
				/>
				{{ $t("Supprimer mon logo") }}
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapState } from "vuex";

	export default {
		data() {
			return {
				uploading: false,
				hovering: false
			};
		},
		computed: {
			...mapGetters(["organization", "config"]),
			...mapState({
				appId: state => state.app.id,
				background: state => state.settings.accentColor.background,
				foreground: state => state.settings.accentColor.foreground
			}),
			logoURL: {
				get() {
					return this.$store.state.home.logoURL;
				},
				set(value) {
					this.$store.commit("logoURL", value);
				}
			},
			logoBinary: {
				get() {
					return this.$store.state.home.logoBinary;
				},
				set(value) {
					this.$store.commit("logoBinary", value);
				}
			}
		},
		async created() {
			if (this.config?.accounting?.printablelogo) {
				this.logoURL = `${this.config?.accounting?.printablelogo}?ts=${Date.now()}`;
			}
		},
		methods: {
			showRemoveImage(status) {
				if (status) {
					this.hovering = true;
				} else {
					this.hovering = false;
				}
			},
			openFileInput() {
				document.getElementById("fileInput").click();
			},
			async uploadImage() {
				try {
					this.uploading = true;

					const file = document.getElementById("fileInput").files[0];

					// eslint-disable-next-line compat/compat
					this.logoURL = URL.createObjectURL(file);
					this.logoBinary = new Blob([file], { type: "image/*" });
				} catch (error) {
					console.error(error);
				} finally {
					this.uploading = false;
				}
			},
			async removeImage() {
				this.logoURL = null;
				this.logoBinary = null;
			}
		}
	};
</script>

<style lang="scss">
	@import "../../scss/variables.scss";

	.logo {
		max-width: 300px;
		max-height: 125px;
		margin-bottom: 8px;
		width: auto !important;
		height: auto !important;
	}

	.btn-image {
		text-align: center;
		width: 275px;
		cursor: pointer;
		padding: 2px 0;
		border: 1px solid rgba(194, 207, 224, 0.7);
		box-sizing: border-box;
		border-radius: 10px;
	}
</style>
